var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mediaType === 'image')?_c('div',{class:_vm.format,style:(`background-image: url(${_vm.mediaUrl})`)}):_c('video',{class:_vm.format,attrs:{"autoplay":"","muted":"","loop":"","id":"myVideo"},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.mediaUrl,"type":"video/mp4"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }